import React, { useEffect, useState, useContext } from 'react';
import Image from 'next/image';
import HomeCard from '@components/Shared/HomeCards/Standard/HomeCard';
import { RecentlyViewedHomesStyles } from './RecentlyViewedHomes.styled';
import { getRecentlyViewedHomes } from '@services/homesService';
import * as tokenService from '@services/tokenService';
import { DXAccountContext } from '@contexts/DXAccountContext';
import { LocationsContext } from '@contexts/LocationsContext';
import { DXFavoritesContext } from '@contexts/DXFavoritesContext';
import { pushGTMEvent } from 'pubweb-smokey/dist/utils/analytics';
import ChevronRightSvg from 'pubweb-smokey/dist/images/svg/iconography-16x16/chevron-right.svg';

const RecentlyViewedHomes = () => {
  const [recentlyViewedHomes, setRecentlyViewedHomes] = useState(null);
  const locationsContext = useContext(LocationsContext);
  const favoritesContext = useContext(DXFavoritesContext);
  const accountContext = useContext(DXAccountContext);

  const visitorToken = tokenService.getVisitorToken();

  const updateRecentlyViewed = () => {
    if (
      typeof visitorToken !== 'undefined' &&
      visitorToken !== null &&
      locationsContext.state.geocode
    ) {
      let geolocation = locationsContext.state.geocode;
      let { distance } = locationsContext.state;

      getRecentlyViewedHomes(
        geolocation.latitude,
        geolocation.longitude,
        distance,
        visitorToken
      ).then((results) => {
        setRecentlyViewedHomes(results);
      });
    }
  };

  useEffect(() => {
    updateRecentlyViewed();
  }, []);

  const homeList =
    recentlyViewedHomes !== null &&
    typeof recentlyViewedHomes.models !== 'undefined'
      ? recentlyViewedHomes.models.slice(0, 3)
      : null;

  return homeList !== null ? (
    <RecentlyViewedHomesStyles>
      <h4 className="recently-viewed-heading">Your recently viewed homes</h4>
      <DXAccountContext.Consumer>
        {({ state }) => {
          let favoritesText = state.account
            ? 'Save your favorite homes'
            : 'My Favorites';

          return (
            <div className="recently-viewed-cards">
              {homeList &&
                homeList.map((home, i) => {
                  return (
                    <HomeCard
                      className="recently-viewed-home-card"
                      onClick={() =>
                        pushGTMEvent('recentlyViewedHomeCardClick')
                      }
                      key={i}
                      showSpecs={false}
                      homeObject={{
                        modelDescription: home.description,
                        altTextDescription: home.description,
                      }}
                      images={[
                        {
                          reference: home.thumbnailImage,
                        },
                      ]}
                      imgComponent={Image}
                      cardLink={`/homes/${home.modelNumber}`}
                      useSlideshow={false}
                      showFavoritingHeart={true}
                      isInStock={false}
                      showStockIndicator={false}
                      isFavorited={
                        !!favoritesContext.state.favoriteModels?.filter(
                          (faveModels) =>
                            faveModels.modelNumber === home.modelNumber
                        )[0]
                      }
                      handleFavoriteClick={(e) => {
                        e.preventDefault();
                        favoritesContext.actions.toggleFavoriteModel(
                          home.modelNumber
                        );
                        pushGTMEvent('clickFavoritesHeart');
                      }}
                    />
                  );
                })}
              {homeList && (
                <div className="cta-card">
                  <HomeCard
                    homeObject={{
                      modelDescription: (
                        <>
                          <div className="favorites-cta-text">
                            {favoritesText}
                          </div>
                          <div className="chevron">
                            <ChevronRightSvg />
                          </div>
                        </>
                      ),
                      altTextDescription: favoritesText,
                    }}
                    images={[
                      {
                        reference: '/public-assets/images/favoriteHouse.svg',
                      },
                    ]}
                    imgComponent={Image}
                    showPricing={false}
                    cardLink="#"
                    onClick={(e) => {
                      e.preventDefault();
                      accountContext.actions.navigateToPortal(
                        '/portal/favorites/'
                      );
                    }}
                    useSlideshow={false}
                    showFavoritingHeart={true}
                    isInStock={false}
                    showSpecs={false}
                    showStockIndicator={false}
                    isFavorited={false}
                  />
                </div>
              )}
            </div>
          );
        }}
      </DXAccountContext.Consumer>
    </RecentlyViewedHomesStyles>
  ) : null;
};

export default RecentlyViewedHomes;
